import { Theme } from "@mui/material";

const createCaseFormStyle = {
  container: {
    maxWidth: 1024,
  },
  headline: {
    textAlign: "center",
  },
  formPaper: {
    padding: "2rem 5rem",
  },
  textField: (theme: Theme) => ({
    backgroundColor: theme.palette.background.note,
  }),
};

export default createCaseFormStyle;
